export default __webpack_public_path__ + "static/media/c2c.9891ea52.webp";